var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img"},[_c('div',{staticClass:"img__container",style:({
      "background-image": "url(" + _vm.imgSrc + ")",
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }